import type { AppGalleryButtonProps } from "../components/AppGalleryButton/next/AppGalleryButton.type";
import * as React from "react";

export const useOnBlur = (props: AppGalleryButtonProps) => {
  return React.useCallback(() => {
    if (props.onBlur && !props.disabled) {
      return props.onBlur(props);
    }
  }, [props]);
};
